import { UserManager, WebStorageStateStore } from 'oidc-client';
import { api, sca } from '../../api';
import { store, persistor } from '../../../store'; 

const config = {
  authority: window.APP_AUTHORITY,
  client_id: window.APP_CLIENT_ID,
  redirect_uri: window.APP_REDIRECT_URI,
  silent_redirect_uri: window.APP_SILENT_REDIRECT_URI,
  post_logout_redirect_uri: window.APP_POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  response_mode: 'query',
  automaticSilentRenew: false,
  scope: window.APP_SCOPE,
  userStore: new WebStorageStateStore({ store: window.sessionStorage })
};

const userManager = new UserManager(config);

let responseInterceptorId = null;

export function setInterceptor(id) {
  responseInterceptorId = id;
}

export async function getUser() {
  return userManager.getUser();
}

export async function signinRedirect() {
  return await userManager.signinRedirect();
}

export function signinRedirectCallback() {
  return userManager.signinRedirectCallback();
}

export async function signoutRedirect() {
  const user = await userManager.getUser();
  if (user === null) return await userManager.signoutRedirect();

  localStorage.clear();
  sessionStorage.clear();
  return await userManager.signoutRedirect({
    id_token_hint: user.id_token,
    post_logout_redirect_uri: userManager.settings.post_logout_redirect_uri
  });
}

export function signoutRedirectCallback() {
  return userManager.signoutRedirectCallback();
}

// export async function oidcLogout() {
//   const user = await userManager.getUser();

//   if (!user || !user.id_token) {
//     console.log("Sem sessão ativa no OIDC limpando localmente");
//     return forceLogoutLocal();
//   }
// await userManager.signoutRedirect({
//     id_token_hint: user.id_token
//   });
// }

// export async function forceLogoutLocal() {
//   //Limpa Redux
//   store.dispatch({ type: 'USER_LOGOUT' });

//   //Limpa OIDC localmente
//   await userManager.removeUser();
//   await userManager.clearStaleState();

//   localStorage.removeItem('persist:RootStorage');

//   //Manda para a tela de acesso
//   window.location.href = window.location.origin + "/requerimento/acesso";
// }

// export async function signoutRedirect() {
//   return await oidcLogout();
// }

export async function getRepresentantes(cpfcnpj) {
  const response = await sca.get(
    `/Usuario/representantes?cpfcnpj=${cpfcnpj}`
  );

  if (response.status == 200) {
    if (response.data.length > 1)
      return response.data;
    else
      return [];
  } else {
    return [];
  }
}

export async function getSessionTimes() {
  try {
    const user = await userManager.getUser();

    if (user)
      return {
        expires_in: user.expires_in,
        expires_at: user.expires_at,
      }
  }
  catch (error) {
    console.error('Erro ao buscar usuario/tempo de sessão');
  }
}

export function clearInterceptor() {
  if (responseInterceptorId !== null) {
    api.interceptors.response.eject(responseInterceptorId);
    responseInterceptorId = null;
  }
}

export default userManager;
